import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["BuilderMobileStepPagination"], {
    steps: $props.steps,
    currentStep: $props.currentStep,
    houseDesign: $props.houseDesign,
    onSelectNext: $setup.onSelectNext,
    onSelectPrev: $setup.onSelectPrev
  }, null, 8, ["steps", "currentStep", "houseDesign"]))
}